import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { publicAPI } from '../services/api';
import { generateImageUrl, formatDate } from '../utils/helpers';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import SectionHeader from '../components/common/SectionHeader';
import LoadingSpinner from '../components/common/LoadingSpinner';
import { FiExternalLink, FiAward } from 'react-icons/fi';
import './Certifications.css';

const Certifications = () => {
  const [certs, setCerts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [ref, isVisible] = useScrollAnimation();

  useEffect(() => {
    publicAPI.getCertifications()
      .then(res => { if (res.success) setCerts(res.data); })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <section className="section certs-page">
      <Helmet><title>Certifications | Deepak Chauhan</title></Helmet>
      <div className="container">
        <SectionHeader title="Certifications" subtitle="Professional certifications and achievements" />
        {loading ? <LoadingSpinner /> : (
          <div className={`certs-grid ${isVisible ? 'fade-in' : ''}`}>
            {certs.map(cert => (
              <div key={cert.id} className="cert-card card">
                <div className="cert-card-image">
                  <img src={generateImageUrl(cert.certificateImageUrl)} alt={cert.name} />
                  <div className="cert-icon"><FiAward /></div>
                </div>
                <div className="cert-card-body">
                  <h3>{cert.name}</h3>
                  <p className="cert-issuer">{cert.issuer}</p>
                  <p className="cert-date">Issued: {formatDate(cert.issueDate)}</p>
                  {cert.description && <p className="cert-desc">{cert.description}</p>}
                  {cert.credentialUrl && (
                    <a href={cert.credentialUrl} target="_blank" rel="noreferrer" className="cert-credential">
                      <FiExternalLink /> Verify Credential
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Certifications;
